import React, { useEffect, useRef, useState } from 'react';
import Tooltip from './Tooltip';
import './FrontPage.css';

// SVG icon components (inline for simplicity)
const YoutubeIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M31.331,8.248c-.368-1.386-1.452-2.477-2.829-2.848-2.496-.673-12.502-.673-12.502-.673,0,0-10.007,0-12.502,.673-1.377,.37-2.461,1.462-2.829,2.848-.669,2.512-.669,7.752-.669,7.752,0,0,0,5.241,.669,7.752,.368,1.386,1.452,2.477,2.829,2.847,2.496,.673,12.502,.673,12.502,.673,0,0,10.007,0,12.502-.673,1.377-.37,2.461-1.462,2.829-2.847,.669-2.512,.669-7.752,.669-7.752,0,0,0-5.24-.669-7.752ZM12.727,20.758V11.242l8.364,4.758-8.364,4.758Z"></path></svg>
);

const InstagramIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M10.202,2.098c-1.49,.07-2.507,.308-3.396,.657-.92,.359-1.7,.84-2.477,1.619-.776,.779-1.254,1.56-1.61,2.481-.345,.891-.578,1.909-.644,3.4-.066,1.49-.08,1.97-.073,5.771s.024,4.278,.096,5.772c.071,1.489,.308,2.506,.657,3.396,.359,.92,.84,1.7,1.619,2.477,.779,.776,1.559,1.253,2.483,1.61,.89,.344,1.909,.579,3.399,.644,1.49,.065,1.97,.08,5.771,.073,3.801-.007,4.279-.024,5.773-.095s2.505-.309,3.395-.657c.92-.36,1.701-.84,2.477-1.62s1.254-1.561,1.609-2.483c.345-.89,.579-1.909,.644-3.398,.065-1.494,.081-1.971,.073-5.773s-.024-4.278-.095-5.771-.308-2.507-.657-3.397c-.36-.92-.84-1.7-1.619-2.477s-1.561-1.254-2.483-1.609c-.891-.345-1.909-.58-3.399-.644s-1.97-.081-5.772-.074-4.278,.024-5.771,.096m.164,25.309c-1.365-.059-2.106-.286-2.6-.476-.654-.252-1.12-.557-1.612-1.044s-.795-.955-1.05-1.608c-.192-.494-.423-1.234-.487-2.599-.069-1.475-.084-1.918-.092-5.656s.006-4.18,.071-5.656c.058-1.364,.286-2.106,.476-2.6,.252-.655,.556-1.12,1.044-1.612s.955-.795,1.608-1.05c.493-.193,1.234-.422,2.598-.487,1.476-.07,1.919-.084,5.656-.092,3.737-.008,4.181,.006,5.658,.071,1.364,.059,2.106,.285,2.599,.476,.654,.252,1.12,.555,1.612,1.044s.795,.954,1.051,1.609c.193,.492,.422,1.232,.486,2.597,.07,1.476,.086,1.919,.093,5.656,.007,3.737-.006,4.181-.071,5.656-.06,1.365-.286,2.106-.476,2.601-.252,.654-.556,1.12-1.045,1.612s-.955,.795-1.608,1.05c-.493,.192-1.234,.422-2.597,.487-1.476,.069-1.919,.084-5.657,.092s-4.18-.007-5.656-.071M21.779,8.517c.002,.928,.755,1.679,1.683,1.677s1.679-.755,1.677-1.683c-.002-.928-.755-1.679-1.683-1.677,0,0,0,0,0,0-.928,.002-1.678,.755-1.677,1.683m-12.967,7.496c.008,3.97,3.232,7.182,7.202,7.174s7.183-3.232,7.176-7.202c-.008-3.97-3.233-7.183-7.203-7.175s-7.182,3.233-7.174,7.203m2.522-.005c-.005-2.577,2.08-4.671,4.658-4.676,2.577-.005,4.671,2.08,4.676,4.658,.005,2.577-2.08,4.671-4.658,4.676-2.577,.005-4.671-2.079-4.676-4.656h0"></path></svg>
);

const XIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M18.42,14.009L27.891,3h-2.244l-8.224,9.559L10.855,3H3.28l9.932,14.455L3.28,29h2.244l8.684-10.095,6.936,10.095h7.576l-10.301-14.991h0Zm-3.074,3.573l-1.006-1.439L6.333,4.69h3.447l6.462,9.243,1.006,1.439,8.4,12.015h-3.447l-6.854-9.804h0Z"></path></svg>
);

const SpotifyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 511.992"><path fill-rule="nonzero" d="M255.998.004C114.617.004 0 114.616 0 255.998c0 141.385 114.617 255.994 255.998 255.994C397.395 511.992 512 397.387 512 255.998 512 114.624 397.395.015 255.994.015l.004-.015v.004zm117.4 369.22c-4.585 7.519-14.426 9.907-21.949 5.288-60.104-36.715-135.771-45.028-224.882-24.669-8.587 1.955-17.146-3.425-19.104-12.015-1.966-8.59 3.394-17.149 12.004-19.104 97.517-22.28 181.164-12.687 248.644 28.551 7.523 4.615 9.907 14.427 5.287 21.949zm31.335-69.704c-5.779 9.389-18.067 12.353-27.452 6.578-68.813-42.297-173.703-54.547-255.096-29.837-10.556 3.188-21.704-2.761-24.906-13.298-3.18-10.556 2.772-21.68 13.309-24.89 92.971-28.209 208.551-14.546 287.575 34.015 9.385 5.778 12.349 18.066 6.574 27.44v-.004l-.004-.004zm2.692-72.583c-82.51-49.006-218.635-53.511-297.409-29.603-12.649 3.836-26.027-3.302-29.859-15.955-3.833-12.657 3.302-26.024 15.959-29.868 90.428-27.452 240.753-22.149 335.747 34.245 11.401 6.755 15.133 21.447 8.375 32.809-6.728 11.378-21.462 15.13-32.802 8.372h-.011z"/></svg>
);

const AppleMusicIcon = () => (
  <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M31.995 8.167c0-0.984-0.083-1.964-0.318-2.922-0.422-1.745-1.417-3.078-2.906-4.057-0.766-0.5-1.609-0.807-2.505-0.969-0.688-0.125-1.385-0.182-2.083-0.198-0.052-0.005-0.109-0.016-0.167-0.021h-16.031c-0.203 0.016-0.406 0.026-0.609 0.036-0.995 0.057-1.984 0.161-2.922 0.536-1.781 0.703-3.068 1.932-3.818 3.703-0.26 0.599-0.391 1.234-0.484 1.88-0.078 0.521-0.12 1.047-0.135 1.573 0 0.042-0.010 0.083-0.010 0.125v16.297c0.010 0.188 0.021 0.375 0.031 0.563 0.068 1.089 0.208 2.167 0.667 3.167 0.865 1.891 2.318 3.135 4.313 3.734 0.557 0.172 1.141 0.25 1.724 0.302 0.74 0.073 1.479 0.083 2.219 0.083h14.708c0.698 0 1.396-0.047 2.094-0.135 1.099-0.141 2.13-0.464 3.063-1.078 1.12-0.74 1.964-1.719 2.505-2.943 0.25-0.563 0.391-1.161 0.495-1.766 0.151-0.901 0.182-1.813 0.182-2.724-0.005-5.063 0-10.125-0.005-15.188zM23.432 13.484v7.615c0 0.557-0.078 1.104-0.328 1.609-0.385 0.786-1.010 1.281-1.849 1.521-0.464 0.135-0.943 0.208-1.427 0.229-1.266 0.063-2.365-0.797-2.589-2.047-0.193-1.031 0.302-2.167 1.385-2.698 0.427-0.208 0.891-0.333 1.354-0.427 0.505-0.109 1.010-0.208 1.51-0.323 0.37-0.083 0.609-0.307 0.682-0.688 0.021-0.083 0.026-0.172 0.026-0.255 0-2.422 0-4.844 0-7.26 0-0.083-0.016-0.167-0.036-0.245-0.052-0.203-0.198-0.323-0.406-0.313-0.214 0.010-0.422 0.047-0.63 0.089-1.016 0.198-2.031 0.401-3.042 0.609l-4.932 0.995c-0.021 0.005-0.047 0.016-0.068 0.016-0.37 0.104-0.5 0.271-0.516 0.656-0.005 0.057 0 0.115 0 0.172-0.005 3.469 0 6.938-0.005 10.406 0 0.563-0.063 1.115-0.286 1.635-0.37 0.854-1.026 1.391-1.911 1.646-0.469 0.135-0.948 0.214-1.438 0.229-1.276 0.047-2.339-0.802-2.557-2.057-0.188-1.083 0.307-2.25 1.536-2.771 0.479-0.198 0.974-0.307 1.479-0.411 0.38-0.078 0.766-0.156 1.146-0.234 0.51-0.109 0.776-0.432 0.802-0.953v-0.198c0-3.948 0-7.896 0-11.844 0-0.167 0.021-0.333 0.057-0.495 0.094-0.38 0.365-0.599 0.729-0.688 0.339-0.089 0.688-0.151 1.031-0.224 0.979-0.198 1.953-0.396 2.932-0.589l3.026-0.615c0.896-0.177 1.786-0.359 2.682-0.536 0.292-0.057 0.589-0.12 0.885-0.141 0.411-0.036 0.698 0.224 0.74 0.641 0.010 0.099 0.016 0.198 0.016 0.297 0 2.547 0 5.094 0 7.641z"></path> </g></svg>
);
const TidalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 512"><path d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0zm50.384 219.459l-50.372 50.383 50.379 50.391-50.382 50.393-50.395-50.393 50.393-50.389-50.393-50.39 50.395-50.372 50.38 50.369 50.389-50.375 50.382 50.382-50.382 50.392-50.394-50.391zm-100.767-.001l-50.392 50.392-50.385-50.392 50.385-50.382 50.392 50.382z"/></svg>
);

void [YoutubeIcon, XIcon, SpotifyIcon, AppleMusicIcon, TidalIcon];

const TicketSaleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
    <path d="M20 7v3.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5V17c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-3.5c.83 0 1.5-.67 1.5-1.5S4.83 10.5 4 10.5V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1z"/>
    <circle cx="7.5" cy="8.5" r="0.5"/>
    <circle cx="7.5" cy="10" r="0.5"/>
    <circle cx="7.5" cy="11.5" r="0.5"/>
    <circle cx="7.5" cy="13" r="0.5"/>
    <circle cx="7.5" cy="14.5" r="0.5"/>
    <circle cx="7.5" cy="16" r="0.5"/>
    <path d="M10 9h6v1h-6zm0 2h6v1h-6zm0 2h4v1h-4z"/>
  </svg>
);

const socials = [
  {
    name: 'Entradas',
    url: 'https://etickets.com.ar/artaud-sinfonico-1777995379/',
    icon: <TicketSaleIcon />,
    disabled: false,
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/artaudsinfonico/',
    icon: <InstagramIcon />,
    disabled: false,
  },
];

const DesktopFrontPage = () => {
  // Toggle carousel on/off
  const CAROUSEL_ENABLED = true;
  
  const [showIntro, setShowIntro] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(1);
  const totalImages = 9;
  const introRef = useRef(null);

  // Carousel effect
  useEffect(() => {
    if (showIntro || !CAROUSEL_ENABLED) return; // Don't run carousel during intro or if disabled
    
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev % totalImages) + 1);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [showIntro, CAROUSEL_ENABLED]);

  // Skip intro on click or after video ends
  useEffect(() => {
    if (!showIntro) return;
    const handler = () => setShowIntro(false);
    const video = introRef.current;
    if (video) {
      video.addEventListener('ended', handler);
      return () => video.removeEventListener('ended', handler);
    }
  }, [showIntro]);

  return (
    <div className="frontpage-root desktop-version">
      {showIntro ? (
        <div className="intro-video-container" onClick={() => setShowIntro(false)}>
          <video
            ref={introRef}
            className="intro-video"
            src="/WebsitePhoneIntro.mp4"
            autoPlay
            muted
            playsInline
          />
          <div className="skip-intro">Click to skip</div>
        </div>
      ) : (
        <div className="desktop-background">
          {/* Background Carousel */}
          <div className="carousel-background-desktop">
            {[...Array(totalImages)].map((_, index) => (
              <div
                key={index + 1}
                className={`carousel-image-desktop ${currentImage === index + 1 ? 'active' : ''}`}
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/carrousel${index + 1}.jpeg)`
                }}
              />
            ))}
            <div className="carousel-overlay-desktop" />
          </div>

          <div className="linktree-title-outside"></div>
          <div
            className="linktree-container"
            style={{ '--linktree-bg-image': `url(${process.env.PUBLIC_URL}/artaud-bg.png)` }}
          >
            <div className="linktree-content">
              <div className="linktree-links">
                {socials.map((social, index) => (
                  !social.disabled ? (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linktree-link"
                      style={{ animationDelay: `${index * 0.1 + 0.3}s` }}
                    >
                      <span className="linktree-icon">{social.icon}</span>
                      <span className="linktree-label">{social.name}</span>
                    </a>
                  ) : (
                    <Tooltip key={social.name} content={social.tooltip || 'No disponible'}>
                      <div
                        className="linktree-link linktree-link-disabled"
                        style={{ animationDelay: `${index * 0.1 + 0.3}s` }}
                        aria-label={social.name}
                      >
                        <span className="linktree-icon">{social.icon}</span>
                        <span className="linktree-label">{social.name}</span>
                      </div>
                    </Tooltip>
                  )
                ))}
              </div>

              <div className="linktree-event-info">
                <div className="linktree-event-date">Próxima función</div>
                <div className="linktree-event-date">23 de Mayo</div>
                <div className="linktree-event-date">21 hs</div>
                <div className="linktree-event-location">Teatro Caras y Caretas</div>
                <div className="linktree-event-address">Corrientes 1518 - Rosario</div>
                  
                <button style={{ opacity: 0 }} disabled={true}
                  className="linktree-event-description"
                  onClick={() => setShowModal(true)}
                >
                  Más de 20 músicos en escena interpretando el mítico álbum de Luis Alberto Spinetta.
                  <br />
                  Arreglos y dirección general:
                  <br />
                  Cristian Loza
                  <br />
                  <small>Click para ver el elenco completo</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Elenco Completo</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="musician-info">
                {/* <p><strong>Director de orquesta:</strong> Agustín Tamagno</p> */}
                <p><strong>Voz:</strong> Agustín Reyna</p>
                <p><strong>Guitarra y efectos:</strong> Cristian Loza</p>
                <p><strong>Teclados:</strong> Mariano Ruggieri</p>
                <p><strong>Bajo eléctrico y contrabajo:</strong> Jorge Palena</p>
                <p><strong>Batería y percusión:</strong> Sebastián Mamet</p>
                <p><strong>Piccolo:</strong> Agostina Delorenzi</p>
                <p><strong>Flauta:</strong> Emiliano Zamora</p>
                <p><strong>Clarinete I:</strong> Julio Kobryn</p>
                <p><strong>Clarinete II:</strong> Fernando Perez</p>
                <p><strong>Saxofón contralto:</strong> Luca Topino</p>
                <p><strong>Saxofón tenor:</strong> Iván Rosianski</p>
                <p><strong>Fagot:</strong> Antonio Herrera</p>
                <p><strong>Trompeta:</strong> Santiago Chinelatto</p>
                <p><strong>Tuba wagneriana:</strong> Jorge Montoya</p>
                <p><strong>Corno francés:</strong> Miryam Wandel-Petersen</p>
                <p><strong>Trombón:</strong> Milton Mendez</p>
                <p><strong>Violín I:</strong> Julia Kobryn/Michele Blando</p>
                <p><strong>Violín II:</strong> Dana Clara Alvarez /Joaquín Vivo</p>
                <p><strong>Viola I:</strong> Franco Giglione</p>
                <p><strong>Viola II:</strong> Eliseo Lazarte</p>
                <p><strong>Violoncello:</strong> Fernando Silva</p>
                {/* <p><strong>Visuales y efectos:</strong> Luis Tamagnini</p> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DesktopFrontPage;